import { DEFAULT_COUNTRY } from "@lezz/shared/constants";
import { z } from "zod";

export const profileUpdateSchema = z.object({
  username: z
    .string()
    .min(3, "O nome de usuário deve ter pelo menos 3 caracteres")
    .max(30, "O nome de usuário deve ter no máximo 30 caracteres")
    .regex(
      /^[a-zA-Z0-9_]+$/,
      "O nome de usuário só pode conter letras, números e underscores"
    ),
  displayName: z
    .string()
    .max(100, "O nome é muito longo")
    .min(1, "O nome é obrigatório")
    .nullable(),
  city: z
    .string()
    .max(100, "O nome da cidade é muito longo")
    .min(1, "A cidade é obrigatória")
    .nullable(),
  state: z
    .string()
    .max(100, "O nome do estado é muito longo")
    .min(1, "O estado é obrigatório")
    .nullable(),
  country: z.string().default(DEFAULT_COUNTRY),
  instagramUsername: z
    .string()
    .max(30, "O nome de usuário do Instagram é muito longo")
    .regex(
      /^[a-zA-Z0-9._]*$/,
      "O nome de usuário do Instagram só pode conter letras, números, pontos e underscores"
    )
    .nullable()
    .transform((val) => val || null),
  shouldShowInstagram: z.boolean().default(false),
  avatarUrl: z.string().nullable(),
});

export type ProfileUpdateFormData = z.input<typeof profileUpdateSchema>;

/** Step 1: Name */
export const profileNameSchema = profileUpdateSchema.pick({
  displayName: true,
});
export type ProfileNameFormData = z.input<typeof profileNameSchema>;

/** Step 2: Username */
export const profileUsernameSchema = profileUpdateSchema.pick({
  username: true,
});
export type ProfileUsernameFormData = z.input<typeof profileUsernameSchema>;

/** Step 3: Location */
export const profileLocationSchema = profileUpdateSchema.pick({
  state: true,
  city: true,
});
export type ProfileLocationFormData = z.input<typeof profileLocationSchema>;

/** Step 4: Instagram */
export const profileInstagramSchema = profileUpdateSchema.pick({
  instagramUsername: true,
});
export type ProfileInstagramFormData = z.input<typeof profileInstagramSchema>;
